import React, { useState } from 'react';
import { DateCalendar, PickersDay } from '@mui/x-date-pickers';
import {
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  TableCell,
  TableRow,
  Table,
  TableContainer,
  TableHead,
  TableBody,
  Box,
  Button,
} from '@mui/material';
import dayjs from 'dayjs';
import { useLearnerContext } from '../../../context/LearnerContext';
import { diffuserTypes } from '../../../constants/broadcast';
import { formatPhoneNumberWithPrefix } from '../../../helpers';
import { TRAINING_STATUSES } from '../../../constants/trainings';
import { PlanningService } from '../../../services/planning';

const PlanningCalendar = ({ trainings }) => {
  const [selected, setSelected] = useState(null);
  const { organization } = useLearnerContext();

  const trainingsByDate = trainings.reduce((acc, t) => {
    const key = dayjs(t.date).format('YYYY-MM-DD');
    if (!acc[key]) acc[key] = [];
    acc[key].push(t);
    return acc;
  }, {});

  const exportExcelPlanning = async () => {
    try {
      await PlanningService.getPlanningExcel();
    } catch (error) {
      console.error('Error exporting planning to Excel:', error);
    }
  }

  return (
    <>
      <Box>
        <Box sx={{ display: 'flex', gap: 1, justifyContent: 'end' }}>
          <Button variant="contained" color="primary" onClick={exportExcelPlanning}>
            Exporter
          </Button>
        </Box>
      </Box>

      <DateCalendar
        value={null}
        onChange={() => {}}
        sx={{
          width: 600, // increase overall width
          height: 600, // increase overall height
          maxHeight: '375px',
          '& .MuiPickersCalendarHeader-root': {
            fontSize: '1.5rem', // bigger month/year header
          },
          '& .MuiPickersDay-root, & .MuiDayCalendar-weekDayLabel': {
            width: 50, // bigger day cells
            height: 50,
            fontSize: '1.1rem',
          },
          '& .MuiPickersDay-root.Mui-selected': {
            bgcolor: 'primary.light', // selected day color (if any)
          },
          '& .MuiDayCalendar-slideTransition': {
            minHeight: '320px', // limit height of month view
          },
        }}
        slots={{
          day: (props) => {
            const dateKey = props.day.format('YYYY-MM-DD');
            const events = trainingsByDate[dateKey] || [];

            if (events.length === 0) return <PickersDay {...props} />;

            return (
              <Tooltip
                title={
                  <div className="tooltip-inner">
                    {Object.entries(
                      events.reduce((acc, t) => {
                        acc[t.trainingName] = (acc[t.trainingName] || 0) + 1;
                        return acc;
                      }, {})
                    ).map(([name]) => (
                      <Typography
                        key={name}
                        variant="body2"
                        sx={{ color: 'white' }}
                      >
                        {name}
                      </Typography>
                    ))}
                  </div>
                }
              >
                <PickersDay
                  {...props}
                  onClick={() => setSelected(events)}
                  sx={{ 
                    bgcolor: 'primary.light', 
                    color: 'white',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                        bgcolor: 'white',
                        color: 'primary.main',
                      }, 
                }}
                />
              </Tooltip>
            );
          },
        }}
      />

      <Dialog
        open={!!selected}
        onClose={() => setSelected(null)}
        fullWidth
        maxWidth="md"
        scroll={'paper'}
      >
        <DialogTitle fontSize={"1rem"}>
          {selected && dayjs(selected[0].date).locale("fr").format("dddd DD MMMM YYYY")}
        </DialogTitle>
        <DialogContent>
          {selected?.map((t) => (
            <div key={t.trainingId} style={{ marginBottom: 16 }}>
              <Typography variant="body2">
                <b>Diffuser:</b> {t.broadcastName}
              </Typography>
              {t.isWelcomeMessage ? null : (<Typography variant="body2"><b>Micro-formation:</b> {t.trainingName}</Typography>)}
              <Typography variant="body2">
              <b>Company:</b> {organization.find(org => org._id === t.company_id)?.name}
              </Typography>
              {t.isWelcomeMessage ? null : (<Typography variant="body2"><b>Type:</b> {diffuserTypes?.[t.type]?.label}</Typography>)}
              {t.isWelcomeMessage ? (<Typography variant="body2"><b>{t.trainingName}</b></Typography>) : null}
              <TableContainer
                component={''}
                style={{ border: '1px solid #c2e3d1', marginTop: '20px' }}
              >
                <Table>
                  <TableHead>
                    <TableRow className="green-border">
                      <TableCell>Prénom</TableCell>
                      <TableCell>Nom</TableCell>
                      <TableCell>Téléphone</TableCell>
                      <TableCell>Date</TableCell>
                      <TableCell>Statut</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {t.mappedRecipients.map((learner) => {
                      return (
                        <TableRow
                          key={learner.phoneNumber}
                          className="green-border"
                        >
                          <TableCell className="green-border">
                            {learner.firstName}
                          </TableCell>
                          <TableCell className="green-border">
                            {learner.lastName}
                          </TableCell>
                          <TableCell className="green-border">
                            {formatPhoneNumberWithPrefix(learner.phoneNumber)}
                          </TableCell>
                          <TableCell className="green-border">
                            {t.isWelcomeMessage
                              ? dayjs(t.welcomeMessage?.date).format(
                                  'HH:mm DD MMM YYYY'
                                )
                              : dayjs(learner.trainingDate || t.date).format(
                                  'HH:mm DD MMM YYYY'
                                )}
                          </TableCell>
                          <TableCell className="green-border">
                            {/* {TRAINING_STATUSES[learner.deliveryStatus]?.label} */}
                            {learner.deliveryStatus}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          ))}
        </DialogContent>
      </Dialog>
    </>
  );
};

export default PlanningCalendar;
